"use client";

import { cn } from "@/lib/utils";
import type { BuddyRequestInput } from "@/validations/buddy";

type IntentSelectorProps = {
  value: BuddyRequestInput["intent"];
  onChange: (value: BuddyRequestInput["intent"]) => void;
};

export function IntentSelector({ value, onChange }: IntentSelectorProps) {
  return (
    <div className="rounded-2xl border border-border bg-surface-alt/60 p-2">
      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          className={cn(
            "cursor-pointer rounded-xl px-4 py-3 text-left transition select-none",
            value === "activity"
              ? "bg-brand text-text-inverse shadow-sm"
              : "hover:bg-surface-hover bg-surface text-text-primary",
          )}
          onClick={() => onChange("activity")}
        >
          <p className="text-base font-semibold">Like an activity</p>
          <p className="text-xs opacity-90">
            Choose an activity you'd love to join them for.
          </p>
        </button>
        <button
          type="button"
          className={cn(
            "cursor-pointer rounded-xl px-4 py-3 text-left transition select-none",
            value === "message"
              ? "bg-brand text-text-inverse shadow-sm"
              : "hover:bg-surface-hover bg-surface text-text-primary",
          )}
          onClick={() => onChange("message")}
        >
          <p className="text-base font-semibold">Personal message</p>
          <p className="text-xs opacity-90">
            Start the conversation with a friendly intro.
          </p>
        </button>
      </div>
    </div>
  );
}
